import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import { hooks as viewHooks } from '@/domains/view';
import { SectionTitle, Breadcrumbs, Pagination } from '@/ui/index';
import { ArrowRight } from '@/components/SvgComponents';
import usePaginatedData from '@/hooks/usePagination';
import NotFoundPage from '@/components/404/NotFoundPage/NotFoundPage';
import { searchNotFoundData } from '@/constants/search';
import { useWindowSize } from '@/hooks/index';

import styles from './SearchList.module.scss';

const SearchList = () => {
  const router = useRouter();
  const { t, lang } = useTranslation();
  const [windowsX] = useWindowSize();

  const itemsPerPage = 12;

  const { data: searchList } = viewHooks.useSearchContent({
    q: router.query.q,
    type: router.query.type,
    lang,
  });

  const { slicedData } = usePaginatedData(searchList?.data, itemsPerPage);

  const redirectToSlug = (item) => {
    return router.push(item?.slug);
  };

  const renderList = (item, index) => {
    return (
      <div
        key={index}
        className={styles.list_item}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <div>
          <h5
            className={styles.list_item__title}
            {...(windowsX < 768 && { onClick: () => redirectToSlug(item) })}
          >
            {item?.title}
          </h5>
          <p
            dangerouslySetInnerHTML={{ __html: item?.description }}
            className={styles.list_item__desc}
          />
          <Breadcrumbs
            className={styles.search_breadcrumbs}
            data={item?.breadcrumbs}
          />
        </div>

        <div className={styles.arrow} onClick={() => redirectToSlug(item)}>
          <ArrowRight width={24} />
        </div>
      </div>
    );
  };
  return searchList?.data?.length > 0 ? (
    <div
      className={styles.search_wrapper}
      itemScope
      itemType='https://schema.org/SearchResultsPage'
    >
      <SectionTitle titleModify='title--large'>
        {t('common:SearchResult', {
          searchText: router.query.q,
          count: searchList?.data?.length,
        })}
      </SectionTitle>
      {slicedData?.map(renderList)}
      <Pagination perpage={itemsPerPage} total={searchList?.data?.length} />
    </div>
  ) : (
    <NotFoundPage data={searchNotFoundData} withTranslate customIcon />
  );
};

export default SearchList;
